<template>
  <el-dialog
    :title="$t('integralShopRule.confirmOperation')"
    :visible.sync="dialogVisible"
    width="30%"
    @close="closeDialog"
  >
    <div style="text-align: center;">
      <p>{{ $t('integralShopRule.confirmDeleteRule') }}</p>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('integralShopRule.cancel') }}</el-button>
      <el-button type="primary" @click="confirmDelete">{{ $t('integralShopRule.confirmDelete') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { deleteIntegralShopRule } from '@/api/shop/integralShopRuleApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'DeleteIntegralShopRule',
  data() {
    return {
      dialogVisible: false,
      deleteData: {
        ruleId: '',
        shopId: ''
      }
    }
  },
  methods: {
    open(row) {
      this.dialogVisible = true
      this.deleteData = {
        ruleId: row.ruleId,
        shopId: getShopId()
      }
    },
    closeDialog() {
      this.dialogVisible = false
    },
    async confirmDelete() {
      try {
        await deleteIntegralShopRule(this.deleteData)
        this.$message.success(this.$t('integralShopRule.deleteSuccess'))
        this.closeDialog()
        this.$emit('refresh')
      } catch (error) {
        console.error('删除积分规则失败:', error)
      }
    }
  }
}
</script>